import icon from './paypal.svg';

import type { Provider } from '../providers'

export default {
    key: 'paypal',
    name: 'PayPal',
    color: '#003087',
    icon
} satisfies Provider;
